import * as React from 'react';
import { SVGProps } from 'react';

const IconThumbDownSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 7H9V1h2v6ZM8 2.047C8 1.417 7.654 1 7 1H3.361c-.694 0-.988.551-1.111.833l-1.083 2.5C1 4.75 1 5.167 1 5.098V6s.167 1 1 1h2.75l-.39 2.71c-.06.29-.016.634.14.79l.667.5L7.72 7.197c.29-.364.28-.52.28-.937V2.047Z" />
  </svg>
);
export default IconThumbDownSizeXs;
